/* Photo cards that point at a product by SKU ([data-sku-link]): when tapped, open exactly the product that has this SKU.
   The shop's product list (/products.json, which every Shopify store publishes) is read once and kept for the visit; the product
   whose variant SKU equals the card's SKU is opened (ignoring upper / lower case). If no variant has exactly that SKU, the product
   whose SKUs start with it (BL-1019 -> BL-1019-ANTQ-BLK-SLVR) is used, and only then the shop's search for it. Without JavaScript
   the link still opens the search results for the SKU. Vanilla JS. */
(function () {
  'use strict';
  var STORE_KEY = 'bnl-sku-map-v1';
  var map = null;       /* { 'sku in lower case': '/products/handle' } */
  var loading = null;

  function readSaved() {
    try { var s = window.sessionStorage.getItem(STORE_KEY); return s ? JSON.parse(s) : null; } catch (e) { return null; }
  }
  function save(m) {
    try { window.sessionStorage.setItem(STORE_KEY, JSON.stringify(m)); } catch (e) { /* storage may be blocked */ }
  }

  function loadMap() {
    if (map) return Promise.resolve(map);
    var saved = readSaved();
    if (saved) { map = saved; return Promise.resolve(map); }
    if (loading) return loading;
    var m = {};
    function page(n) {
      return window.fetch('/products.json?limit=250&page=' + n, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          var list = (d && d.products) || [];
          list.forEach(function (p) {
            (p.variants || []).forEach(function (v) {
              var k = String(v.sku || '').trim().toLowerCase();
              if (k && !m[k]) m[k] = '/products/' + p.handle;
            });
          });
          return list.length === 250 && n < 8 ? page(n + 1) : null;
        });
    }
    loading = page(1).then(function () { map = m; save(m); return m; }).catch(function () { map = m; return m; });
    return loading;
  }

  function pick(m, sku) {
    var k = String(sku || '').trim().toLowerCase();
    if (!k) return '';
    if (m[k]) return m[k];
    var keys = Object.keys(m);
    for (var i = 0; i < keys.length; i++) { if (keys[i].indexOf(k + '-') === 0) return m[keys[i]]; }
    for (var j = 0; j < keys.length; j++) { if (keys[j].indexOf(k) === 0) return m[keys[j]]; }
    return '';
  }

  function suggest(sku) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(sku) + '&resources[type]=product&resources[limit]=1&resources[options][fields]=variants.sku,title';
    return window.fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var list = d && d.resources && d.resources.results && d.resources.results.products;
        return list && list[0] && list[0].url ? list[0].url : '';
      })
      .catch(function () { return ''; });
  }

  function find(sku) {
    return loadMap().then(function (m) {
      var url = pick(m, sku);
      return url || suggest(sku);
    });
  }

  /* read the product list in the background once the page is idle, so the first tap is instant */
  if (window.fetch && document.querySelector('a[data-sku-link]')) {
    var warm = function () { loadMap(); };
    if (window.requestIdleCallback) window.requestIdleCallback(warm, { timeout: 4000 }); else window.setTimeout(warm, 1500);
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest ? e.target.closest('a[data-sku-link]') : null;
    if (!a || !window.fetch) return;
    var sku = a.getAttribute('data-sku-link');
    if (!sku) return;
    e.preventDefault();
    var fallback = a.href;
    find(sku).then(function (product) { window.location.href = product || fallback; });
  });
})();
